import { render, staticRenderFns } from "./EditDailyWageReportDialog.vue?vue&type=template&id=4429060c&"
import script from "./EditDailyWageReportDialog.vue?vue&type=script&lang=ts&"
export * from "./EditDailyWageReportDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports